import Phaser from 'phaser';
import { CONSTANTS } from './game/constants';
import { BootScene } from './game/scenes/BootScene';
import { PreloadScene } from './game/scenes/PreloadScene';
import { MenuScene } from './game/scenes/MenuScene';
import { GameScene } from './game/scenes/GameScene';
import { LevelCompleteScene } from './game/scenes/LevelCompleteScene';
import { BriefingScene } from './game/scenes/BriefingScene';
import { FinalScene } from './game/scenes/FinalScene';
import { DefeatScene } from './game/scenes/DefeatScene';

const config: Phaser.Types.Core.GameConfig = {
  parent: 'game-container',
  type: Phaser.AUTO,
  width: CONSTANTS.CANVAS_WIDTH,
  height: CONSTANTS.CANVAS_HEIGHT,
  scale: {
    mode: Phaser.Scale.RESIZE,
    parent: 'game-container',
    width: CONSTANTS.CANVAS_WIDTH,
    height: CONSTANTS.CANVAS_HEIGHT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    expandParent: false,
  },
  backgroundColor: '#5ec0e6',
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: CONSTANTS.GRAVITY * 60 },
      debug: false,
    },
  },
  render: { antialias: true, pixelArt: false, roundPixels: false },
  scene: [BootScene, PreloadScene, MenuScene, GameScene, LevelCompleteScene, BriefingScene, FinalScene, DefeatScene],
};

export const game = new Phaser.Game(config);
